<template>
    <div class="panel__container">
        <users-table v-if="showUsers" :admin="true" :users="users">
            <template slot="header">
                <router-link to="/people/options" data-locator="add-user" class="button button--small button--primary users__button">
                    <span>Add people</span>
                    <icon type="circle-plus" color="white" size="12" />
                </router-link>
            </template>
            <template v-slot="{ user }">
                <more-navigation v-slot="scope" title="Manage people" orientation="horizontal">
                    <li v-if="currentUser.id !== user.id && user.is_active"  class="dropdown-menu__item">
                        <a href="#" @click.prevent="deactivateUser(user, scope)" data-locator="deactivate" class="dropdown-menu__link">Deactivate</a>
                    </li>
                    <li v-if="currentUser.id !== user.id && user.is_inactive" class="dropdown-menu__item">
                        <a href="#" @click.prevent="activateUser(user, scope)" data-locator="remove" class="dropdown-menu__link">Activate</a>
                    </li>
                    <li class="dropdown-menu__item">
                        <a href="#" @click.prevent="editUser(user, scope)" data-locator="edit" class="dropdown-menu__link">Edit</a>
                    </li>
                    <li v-if="currentUser.id !== user.id" class="dropdown-menu__item">
                        <a href="#" @click.prevent="removeUser(user, scope)" data-locator="remove" class="dropdown-menu__link dropdown-menu__link--danger">Delete</a>
                    </li>
                </more-navigation>
            </template>
        </users-table>

        <confirm ref="confirmRemoval" :danger="true" @shown="showUsers = false" @hidden="showUsers = true">
            <h3 slot="title" class="confirmation__title">Delete user</h3>
            Are you sure you want to remove this user from {{ currentTenant.display_name }}?
            <template slot="message">This action cannot be undone</template>
            <template slot="confirm">Delete</template>
        </confirm>

        <confirm ref="confirmDeactivation" @shown="showUsers = false" @hidden="showUsers = true">
            <h3 slot="title" class="confirmation__title">Deactivate user</h3>
            <template slot="message">Deactivated users can't login to the {{ currentTenant.display_name }} workspace. They can be re-activated at any time</template>
            Are you sure you want to de-activate this user?
        </confirm>
    </div>
</template>
<script>
/* global EventBus, app */
import { mapGetters, mapState } from 'vuex'
import Icon from '../../Global/Icon'
import Confirm from '../../Global/Confirm'
import MoreNavigation from '../../Global/MoreNavigation'
import UsersTable from '../../Global/Users/UsersTable'

export default {
    data () {
        return {
            showUsers: true,
            currentTenant: app.currentTenant
        }
    },

    methods: {
        removeUser (user, menu) {
            this.$refs.confirmRemoval.show(user.display_name, () => {
                return this.$store.dispatch('tenant/removeUser', user).then(() => {
                    EventBus.$emit('newSnackbar', `${user.display_name ? user.display_name : user.email} removed from ${this.currentTenant.display_name}`)
                })
            })

            menu.close()
        },

        deactivateUser (user, menu) {
            this.$refs.confirmDeactivation.show(user.display_name, () => {
                return this.$store.dispatch('tenant/deactivateUser', user).then(() => {
                    EventBus.$emit('newSnackbar', `${user.display_name} was deactivated`)
                })
            })

            menu.close()
        },

        activateUser (user, menu) {
            this.$store.dispatch('tenant/activateUser', user).then(() => {
                EventBus.$emit('newSnackbar', `${user.display_name} was activated`)
            })

            menu.close()
        },

        editUser (user) {
            this.$router.push({ path: `/people/${user.id}/edit` })
        }
    },

    computed: {
        ...mapState('users', {
            currentUser: 'current'
        }),

        ...mapGetters({
            users: 'tenant/sortedUsers'
        })
    },

    components: {
        Icon,
        Confirm,
        UsersTable,
        MoreNavigation
    }
}
</script>
